export default __webpack_public_path__ + "static/media/burger-icon.0b27f141.svg";